import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { InstalmentsBar } from 'day8-react/build/new-components';
import { toast, pricingHelpers, CurrencyContext, FormatCurrency } from 'day8-ui';
import {
  PaymentBridge
} from 'day8-react';
import { getExtraBookingTermsUrl } from '../../../../helpers/legalDocumentUrls';
import { useToolipModal } from '../../../../context/TooltipModalContext';

const PayFullOption = ({
  booking,
  onError,
  createPayment,
  checkPaymentInfo,
  onPaymentSuccess,
  email,
  girls,
  guys,
  isYachtsAndFriends,
  companyId,
  activePaymentOption,
  hasPromoCodeApplied,
  isPaymentOverLimit
}) => {
  const { openTooltipModal } = useToolipModal();
  const currencyContext = useContext(CurrencyContext);
  const order = booking.mainOrder;
  const amount = isPaymentOverLimit ? order.gross / 2 : order.gross;
  const percentage = isPaymentOverLimit ? 50 : 100;



  const amountText = (
    <FormatCurrency
      amount={amount / 100}
      baseCurrency={order.currency}
      round={false}
    />
  );

  const items = [
    {
      width: percentage,
      status: 'ok',
      type: 'deadline',
      tooltipTitle: 'Pay now 100%',
      amount: amount / 100,
      dueDate: moment.now()
    }
  ];
  if (isPaymentOverLimit) {
    items.push({
      width: percentage,
      status: 'pending',
      type: 'deadline',
      amount: amount / 100,
      dueDate: booking.mainOrder.dueDate
    });
  }
  return (
    <div className={`dui-pt-8`}>
      <InstalmentsBar items={items} currency={order.currency} />
      {isPaymentOverLimit && (
        <p className='dui-text-sm dui-text-gray-500 dui-mt-4'>
          Due to payment processing limits, bookings over €25,000 must be split into two payments.
        </p>
      )}
      <div className={`dui-pt-8`}>
        <PaymentBridge
          amountString={amountText}
          registeredAmount={amount}
          paidAmount={pricingHelpers.convertPrice(
            amount,
            order.currency,
            currencyContext.currency,
            currencyContext.rates
          )}
          onError={onError}
          createPayment={createPayment}
          checkPaymentInfo={checkPaymentInfo}
          onPaymentSuccess={onPaymentSuccess}
          orderId={order.id}
          currency={currencyContext.currency}
          email={email}
          bookingId={booking.id}
          visa
          amex
          girls={girls}
          guys={guys}
          minAge={booking?.destination?.ageLimit || 20}
          mastercard
          product={isYachtsAndFriends ? 'Yachts and Friends' : 'Yacht Week'}
          baseUrl="https://www.theyachtweek.com"
          companyId={companyId}
          weekTerms={getExtraBookingTermsUrl(booking)}
          destinationId={booking?.destination?.id}
          activePaymentOption={activePaymentOption}
          travelInsuranceCheckBox
          skipCardCharges
          hasPromoCodeApplied={hasPromoCodeApplied}
          openTooltipModal={openTooltipModal}
          toast={toast}
          departureDate={booking?.week?.guestBeginDate}
          returnDate={booking?.week?.guestEndDate}
          disableWalletPayments={false}
          disableApplePay={isYachtsAndFriends}
        />
      </div>
    </div>
  );
};

PayFullOption.propTypes = {
  booking: PropTypes.object,
  createPayment: PropTypes.func.isRequired,
  checkPaymentInfo: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  isYachtsAndFriends: PropTypes.bool,
  onError: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  girls: PropTypes.number.isRequired,
  guys: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  setActivePaymentOption: PropTypes.func.isRequired,
  activePaymentOption: PropTypes.string.isRequired,
  hasPromoCodeApplied: PropTypes.bool
};

export default PayFullOption;
